export const REFERRAL_DISCOUNT_PERCENTAGE = 35
export const REFERRAL_REWARD_AMOUNT = 25
export const REFERRAL_SLUG = 'i'

export const REFERRAL_CAMPAIGN_GOAL = 3
export const REFERRAL_CAMPAIGN_REWARD_AMOUNT = 300
export const REFERRAL_MULTIPLIER_CAMPAIGN_REWARD_TOTAL = 375
export const REFERRAL_SUPERCHARGED_CAMPAIGN_THIRD_REWARD_AMOUNT = 250

export const REFERRAL_SOURCE_BLANK = 'blankreferral'
